export default __webpack_public_path__ + "23794380b08e7019323e36f64bcc126f.png";